import { AuthContext } from '@repo-level/core-front';
import { ModalsContext, ModalType } from 'contexts/modal';
import {
  AuthMissedField,
  isNeedAuthDataConfirmation,
} from 'modules/googleAuth';
import { useContext, useEffect } from 'react';

export const useNewTermsAndConditions = () => {
  const { user } = useContext(AuthContext);
  const { handleModal, modals } = useContext(ModalsContext);

  useEffect(() => {
    if (modals.length) return;

    if (isNeedAuthDataConfirmation(user)) return;

    if (user?.authFieldsMissed?.includes(AuthMissedField.Terms)) {
      handleModal(ModalType.NewTermsAndConditions)();
    }
  }, [handleModal, modals.length, user]);
};
